import React from 'react';

// Apple 登录提供者组件
// 这是一个占位符组件，用于与 Google 保持一致的结构
// Apple 的登录不需要全局提供者包装，而是直接在按钮上配置
export function AppleAuthProvider({ children }: { children: React.ReactNode }) {
  return <>{children}</>;
} 
